import mixpanel from "mixpanel-browser";
import dayjs from "./dayjs";
import { ENV } from "@/constants/env";
import { GIT_REV } from "../constants/env";

/**
 * 믹스패널에 이벤트를 전달합니다.
 * @param {*} eventName - 이벤트 이름을 지정합니다.
 * @param {*} properties - 이벤트를 전달할 때 같이 보낼 속성값을 전달합니다.
 */
export const trackEvent = (eventName, properties) => {
  mixpanel.track(eventName, properties);
};

/**
 * 믹스패널에 전역 속성값을 등록합니다.
 * @param {*} properties - 이벤트에 전달할 전역 속성값
 */
export const registerGlobalProperties = (properties) => {
  mixpanel.register(properties);
};

/**
 * 로그인 이후, 믹스패널에 사용자를 등록합니다.
 * @param {*} userId - 유저 유니크 값
 * @param {*} properties - 유저 정보
 */
export const identifyUser = (userId, properties) => {
  mixpanel.identify(userId);
  mixpanel.people.set({ ...properties, loginTime: dayjs().format() });
};

/**
 * 로그아웃 이후, identifyUser을 이용한 유저 등록을 취소 시킵니다.
 */
export const resetUser = () => {
  mixpanel.reset();
};

/**
 * 믹스패널 초기화
 */
export const initMixpanel = () => {
  const isProd = ENV === "prod";

  mixpanel.init(
    isProd
      ? "d61dcd25d8b61e9fb3e66670102647c2" // for prod
      : "461b1f49969cdf09c91567d666263810", // for dev, qa
    {
      persistence: "localStorage",
      track_pageview: true,
      debug: ENV !== "prod",
    }
  );

  // default global properties
  registerGlobalProperties({
    ENV: ENV,
    Version: GIT_REV,
  });
};
